module.exports = __WEBPACK_EXTERNAL_MODULE_37__;


//////////////////
// WEBPACK FOOTER
// external "gemini/lib/@waca/core-client/js/core-client/ui/core/Class"
// module id = 37
// module chunks = 0 3